import { render, staticRenderFns } from "./AdminPartnerCompanyList.vue?vue&type=template&id=45599acc&scoped=true&"
import script from "./AdminPartnerCompanyList.vue?vue&type=script&lang=js&"
export * from "./AdminPartnerCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45599acc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
